import axios from '../axios'

// モジュール完了状況の更新（講師/管理者）
// payload = { student_id, course_id, completed_module_ids?, current_module_position? }
const putModuleProgressApi = async (payload) => {
  return await axios.put('api/lms/module-progress', payload)
}

export default putModuleProgressApi
